// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__l3_Yd","content":"ManualTimeModal_content__2ETLD"};